/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import includes from "ramda/src/includes"

const FOOD_MERCHANT_PRD = "https://food-merchant.grab.com"
const FOOD_MERCHANT_STG = "https://food-merchant.stg-myteksi.com"
const TROY_PRD = "https://merchant.grab.com"
const TROY_PRD_GITLAB_MIGRATION_TEMPORARY = "https://merchant-gt.grab.com" // TODO remove when the migration is done https://grab.slack.com/archives/C01BATYPA6B/p1664792954118579
const TROY_STG = "https://stg-mmp-view01.stg-grabpay.com"
const WEBKIT_STG_ORIGIN_PATTERN = /^https:\/\/[a-z0-9]+-foodmerchantportal\.webkit\.stg-myteksi\.com$/
const OTHER_STG_DOMAINS = [
  "https://stg-merchantcentral.stg-grabpay.com",
  "https://stg-troyportal.stg-grabpay.com",
  "https://merchant.stg-myteksi.com",
]

const isFoodMerchantPrd = (): boolean =>
  window.location.origin === FOOD_MERCHANT_PRD
const isFoodMerchantStg = (): boolean =>
  window.location.origin === FOOD_MERCHANT_STG
export const isTroyPrd = (): boolean =>
  window.location.origin === TROY_PRD ||
  window.location.origin === TROY_PRD_GITLAB_MIGRATION_TEMPORARY
export const isTroyStg = (): boolean => window.location.origin === TROY_STG
const isOtherStgDomain = (): boolean =>
  includes(window.location.origin, OTHER_STG_DOMAINS)
export const isWebkitStg = (): boolean =>
  WEBKIT_STG_ORIGIN_PATTERN.test(window.location.origin)

export const isPrd = (): boolean => isTroyPrd() || isFoodMerchantPrd()
export const isStg = (): boolean =>
  isTroyStg() || isFoodMerchantStg() || isOtherStgDomain() || isWebkitStg()
export const isDev = (): boolean => !isStg() && !isPrd()
export const isDevBuildOrBranchPreview = (): boolean =>
  process.env.NODE_ENV === "development" || isWebkitStg()

export const getApiUrl = () => {
  let url = "/api"
  if (isStg()) {
    url = "https://api.stg-myteksi.com"
  } else if (isPrd()) {
    url = "https://api.grab.com"
  }
  return url
}

export const getPortalUrl = () => {
  let url = "/portal"
  if (isStg()) {
    url = "https://portal.stg-myteksi.com"
  } else if (isPrd()) {
    url = "https://portal.grab.com"
  }
  return url
}

export const getTroyUrl = () => {
  let url = ""
  if (isStg()) {
    url = "https://merchant.stg-myteksi.com"
  } else if (isPrd()) {
    url = "https://merchant.grab.com"
  }
  return url
}

export const getHermesUrl = () => {
  let url = "https://hermes2.stg-myteksi.com:8092/ws" // localhost & staging shared same hermes host
  if (isPrd()) {
    url = "https://hermes2.grab.com:8092/ws"
  }
  return url
}

export const getFoodMerchantUrl = () => {
  let url = ""
  if (isStg()) {
    url = FOOD_MERCHANT_STG
  } else if (isPrd()) {
    url = FOOD_MERCHANT_PRD
  }

  return url
}

export const getAssetsMobileUrl = () => {
  if (isPrd()) {
    return "https://assets-mobile.grab.com"
  }
  return "https://assets-mobile.stg-myteksi.com"
}
